/**
 * Header component for notifications page.
 * Fully presentational - no props needed.
 */
export function NotificationsHeader() {
  return (
    <div className="bg-surface border-b border-default sticky top-16 z-10">
      <div className="max-w-3xl mx-auto px-4 py-4">
        <h1 className="text-xl font-semibold text-main">Notifications</h1>
      </div>
    </div>
  );
}
